import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[appViewContainer]',
	exportAs: 'appViewContainer',
})
export class ViewContainerDirective {
	constructor(public viewContainerRef: ViewContainerRef) {}
}
